import React from 'react';
import { motion } from 'framer-motion';

const quotes = [
  { text: 'What are you thinking?', reply: '"Nothing."' },
  { text: 'Are you okay?', reply: '"I\'m fine."' },
  { text: 'Do you love me?', reply: '"Of course." — then silence.' },
];

const StoryHook = () => (
  <section id="story" className="py-24 bg-white relative">
    <div className="max-w-5xl mx-auto px-6">
      <div className="grid md:grid-cols-2 gap-16 items-center">

        {/* Left: Story */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.8 }}
        >
          <span className="text-brand-accent font-semibold tracking-widest uppercase text-xs">The Silent Gap</span>
          <h2 className="text-4xl font-serif font-bold text-brand-dark mt-3 mb-6 leading-tight">
            You know he's a good man.<br />
            <span className="text-brand-accent italic font-normal">But the silence is deafening.</span>
          </h2>
          <div className="space-y-5 text-slate-600 leading-relaxed">
            <p>
              It starts with a look — a magnetic connection. Then, slowly, subtle walls appear. You reach for him and feel a distance you can't name, navigating the maze of his heart in the dark.
            </p>
            <p>
              Society tells us men are simple. But a good man's heart is a fortress — built to protect, to provide, and to endure. He isn't emotionally absent. He speaks a different language.
            </p>
            <p className="font-semibold text-brand-dark text-lg">
              To love him, you don't need to change him. You need the key to his fortress.
            </p>
          </div>
        </motion.div>

        {/* Right: Conversation cards */}
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="space-y-4"
        >
          {quotes.map((q, i) => (
            <div key={i} className="bg-slate-50 rounded-2xl p-6 border border-slate-100">
              <p className="text-slate-500 text-sm mb-2">You ask: <em>"{q.text}"</em></p>
              <p className="text-brand-dark font-serif text-xl font-semibold">He says: {q.reply}</p>
            </div>
          ))}
          <div className="bg-brand-accent/10 border border-brand-accent/30 rounded-2xl p-6">
            <p className="text-brand-dark font-medium leading-relaxed">
              This book gives you the decoder. Learn what he actually means — and how to reach him where he lives.
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);

export default StoryHook;